import React, { useRef, useEffect } from "react";
import "../../styles/Calendar.css";
import { getIsAppointmentsAvailable } from "services/MeetScheduling/getAll";

const errorSnackbar = {
  isSnackBarOpen: true,
  severity: "error",
  message: "An error has occurred",
};

export const Calendar = ({ selectedTeacher, closeCalendar, showSnackBar }) => {
  const Iframe = useRef(null);

  useEffect(() => {
    isAppointmentsAvailable();
  }, []);

  const isAppointmentsAvailable = async () => {
    const { data } = await getIsAppointmentsAvailable();
    if (!data.canScheduleMeet) {
      showSnackBar({
        ...errorSnackbar,
        message:
          "You cannot schedule a meeting, please check your session plan!",
      });
      closeCalendar();
    }
  };

  return (
    <>
      <iframe
        ref={Iframe}
        src={`${selectedTeacher}?embed=1&embedType=iframe`}
        loading="lazy"
        style={{
          border: "none",
          minWidth: "320px",
          minHeight: "544px",
        }}
        className={"iframe-calendar-speaking"}
        id="zcal-invite"
        title="zcal"
      ></iframe>
      <div className="flex flex-col justify-start items-center -mt-0">
        <button
          className="block lg:hidden p-2 px-8 rounded-full bg-[#CF7831] hover:opacity-75  text-white font-semibold w-fit mb-4 mt-6 md:mt-0"
          onClick={closeCalendar}
        >
          ← Back to all coaches
        </button>
      </div>
    </>
  );
};
